/**
 * API'den gelen role: tek string ("ADMIN"), virgüllü ("ADMIN,MUHASEBE") veya dizi olabilir.
 */
export function normalizeRoles(role) {
    if (role == null) return []
    if (Array.isArray(role)) {
        return role.map((r) => String(r).trim()).filter(Boolean)
    }
    const s = String(role).trim()
    if (!s) return []
    return s.split(/[,;]+/).map((x) => x.trim()).filter(Boolean)
}

export function hasAnyRole(role, ...codes) {
    const mine = new Set(normalizeRoles(role))
    return codes.some((c) => mine.has(c))
}

export function isAdmin(role) {
    return hasAnyRole(role, 'ADMIN')
}

export function hasMuhasebeRole(role) {
    return hasAnyRole(role, 'MUHASEBE')
}

/**
 * Yeni talep açma: admin + müteahhit (API rol kodlarıyla eşleşmeli).
 * Yapı denetim, beton santrali, muhasebe, çalışan vb. oluşturamaz.
 */
const DEMAND_CREATOR_ROLE_CODES = [
    'MUTEAHHIT',
    'MUTEAHHIT_FIRMA',
    'MUSTAHSIL',
]

export function canCreateDemand(role) {
    return isAdmin(role) || hasAnyRole(role, ...DEMAND_CREATOR_ROLE_CODES)
}

/**
 * Talep üzerinde statü güncelleme (iptal / ilerletme vb.) ve ilgili modal.
 * Admin, yapı denetim ve çalışan (laboratuvar/personel) rolleri.
 */
const DEMAND_WORKFLOW_ROLE_CODES = [
    'YAPI_DENETIM',
    'EMPLOYEE',
    'PERSONEL',
    'CALISAN',
    'LABORATUVAR',
    'LABORANT',
]

export function canManageDemandWorkflow(role) {
    return isAdmin(role) || hasAnyRole(role, ...DEMAND_WORKFLOW_ROLE_CODES)
}
